import React from 'react'
import { componentGetCompareProps, MessageBusWrapper, BuildMessageBusEvents } from 'common-tools/index'
import AceEditor from 'react-ace'
import _ from 'common-tools/LodashHelper'
import acorn from 'acorn'
import Interpreter from 'interpreter'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/theme-github'
import { beautify } from 'ace-builds/src-noconflict/ext-beautify'
import { compose } from 'common-data/datahelpers'

export const CodeEditorEvents = BuildMessageBusEvents('Controls.CodeEditor', ['Format', 'Parse', 'SetFocus'])

class CodeEditorPlain extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      containerHeight: '0px',
      containerWidth: '0px',
      firstRenderDone: false,
      code: '',
      annotations: []
    }
  }

  wrapperDiv = null
  editor = null

  componentDidMount () {
    this.updateDimensions()

    const { value = '' } = this.props
    if (value) {
      this.parseCode(value)
    }
  }

  onNewMessage (msg) {
    switch (msg.Type) {
      case CodeEditorEvents.Format:
        if (this.editor) {
          beautify(this.editor.editor.session)
        }
        break
      case CodeEditorEvents.Parse:
        if (this.editor) {
          this.parseCode(this.state.code)
        }
        break
      case CodeEditorEvents.SetFocus:
        if (this.editor) {
          this.editor.focus()
        }
        break
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (this.props.value === nextProps.value) {
      return false
    } else {
      return true
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const splitSize = componentGetCompareProps('splitSize', this.props, prevProps, 0)

    if (!this.props.noResize && splitSize.HasChanged) {
      this.updateDimensions()
    }
  }

  parseCode (code) {
    try {
      acorn.parse(code, Interpreter.PARSE_OPTIONS)
      if (this.editor) {
        this.editor.editor.getSession().clearAnnotations()
      }
    } catch (error) {
      if (error.loc) {
        let workerAnnotations = this.editor.editor.getSession().getAnnotations() || []
        const allnotations = _.concat([], [
          { row: error.loc.line - 1, column: error.loc.column, type: 'error', text: error.message, acorn: true }
        ], _.reject(workerAnnotations, (a) => { return a.acorn === true }))
        this.editor.editor.getSession().setAnnotations(allnotations)
      } else {
        console.log('Parse Error ++++++++++++++++++++++++++++++++')
        console.log(error.message)
      }
    }
  }

  updateDimensions () {
    if (this.wrapperDiv) {
      const rect = this.wrapperDiv.getBoundingClientRect()
      this.setState({
        containerHeight: `${rect.height}px`,
        containerWidth: `${rect.width}px`
      })
    }
  }

  onChange = (newCode, event) => {
    const { onChange } = this.props

    this.setState({
      code: newCode
    }, () => {
      if (_.isFunction(onChange)) {
        onChange(newCode, event)
      }
    })
  }

  setEditor (e) {
    this.editor = e

    if (e) {
      this.editor.editor.session.$worker.send('changeOptions', [{ asi: true }])
      // this.editor.editor.session.on('changeMode', function (e, session) {
      //   if (session.getMode().$id === 'ace/mode/javascript') {
      //     if (session.$worker) {
      //       session.$worker.send('changeOptions', [{
      //         asi: true // disable "Missing semicolon." warning in editor for JavaScript
      //       }])
      //     }
      //   }
      // })
    }
  }

  render () {
    const { containerHeight, containerWidth } = this.state
    const { className, noResize, ...rest } = this.props
    const allRestProps = _.omit(rest, ['onChange', 'annotations'])

    if (noResize) {
      return <AceEditor
        {...allRestProps}
        // onValidate={this.onValidate}
        ref={this.setEditor}
        onChange={this.onChange}
        height='100%'
        width='100%'
        theme='github'
        mode='javascript'
        setOptions={{
          tabSize: 4
        }}
      />
    } else {
      return <div className={className} ref={(c) => { this.wrapperDiv = c }}>
        <AceEditor
          {...allRestProps}
          // onValidate={this.onValidate}
          ref={this.setEditor}
          onChange={this.onChange}
          height={containerHeight}
          width={containerWidth}
          theme='github'
          mode='javascript'
        />
      </div>
    }
  }
}

export const CodeEditor = compose(
  MessageBusWrapper({
    listenForAllMessages: true
  })
)(CodeEditorPlain)
